<div class="cb-margin flex-col">
    <app-house-and-land-search
        (emitFilterEvent)="getFilterredLots($event)"
        [lots]="lots"
        (emitResultSizeEvent)="setResultSize($event)"
    ></app-house-and-land-search>
    <div class="flex-wrap">
        @for (item of lots; track item) {
            <cb-house-and-land-card
                class="flex-col"
                [ngStyle]="{ 'flex-basis': defaultCardSize }"
                [lot]="item"
            >
            </cb-house-and-land-card>
        }
        @if (!lotsLoaded) {
            <cb-loading-spinner message="Loading House and Land Lots"></cb-loading-spinner>
        }
        @if (lotsLoaded && lots.length < 1) {
            <cb-info-message class="cb-margin-top" message="There are no House and Land Lots found">
            </cb-info-message>
        }
    </div>
    @if (lotsLoaded && lots.length > 0 && noMoreResults) {
        <cb-info-message class="cb-margin-top" message="There are no more search results">
        </cb-info-message>
    }
</div>
